import { showToast } from '@/components/base/Toast';
import { rankList } from '@/mocks/home';

export default function RankingBoard() {
  return (
    <section id="ranking" className="w-full bg-background-50">
      <div className="w-full px-4 py-16 md:px-8 md:py-20">
        <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="mb-4 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-trophy-line text-lg" />
              </span>
              <span className="text-xs font-medium uppercase tracking-[0.25em] text-secondary-600">
                Weekly Ranking
              </span>
            </div>
            <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              本周热度榜
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              以浏览收藏综合热度排序，帮你快速锁定当下最受欢迎的善良的女秘书角色扮演资源，
              榜单每周更新一次。
            </p>
            <div className="mt-6 flex flex-col gap-3">
              <div className="flex items-center gap-2 rounded-md bg-accent-100 px-4 py-3">
                <i className="ri-line-chart-line text-lg text-accent-700" />
                <span className="text-sm text-accent-900">热度按周统计，综合浏览与收藏</span>
              </div>
              <button
                type="button"
                onClick={() => showToast('完整榜单为静态展示')}
                className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-secondary-600"
              >
                查看完整榜单
                <i className="ri-arrow-right-up-line text-base" />
              </button>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {rankList.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => showToast('静态展示：榜单条目暂不可点开')}
                  className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-3 text-left transition-colors duration-200 hover:border-accent-300 hover:bg-accent-50 md:gap-5 md:p-4"
                >
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold md:h-10 md:w-10 ${
                      item.rank <= 3
                        ? 'bg-accent-500 text-background-50'
                        : 'bg-background-300 text-foreground-700'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="h-16 w-16 shrink-0 overflow-hidden rounded-md border border-background-200 md:h-20 md:w-20">
                    <img
                      src={item.cover}
                      alt={`${item.title} - 善良的女秘书 热度榜封面`}
                      title={`${item.title} - 善良的女秘书角色扮演 热度榜`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {item.title}
                    </h3>
                    <div className="mt-2 flex items-center gap-3">
                      <div className="h-1.5 w-full max-w-[220px] overflow-hidden rounded-full bg-background-300">
                        <span
                          className="block h-full rounded-full bg-accent-500"
                          style={{ width: `${item.score}%` }}
                        />
                      </div>
                      <span className="shrink-0 font-heading text-xs font-bold text-accent-700">
                        {item.score}
                      </span>
                    </div>
                    <div className="mt-1.5 flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-eye-line" />
                      {item.views} 浏览
                    </div>
                  </div>
                  <i className="ri-arrow-right-s-line hidden text-xl text-foreground-400 transition-transform duration-200 group-hover:translate-x-1 group-hover:text-accent-600 md:block" />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}